// extracted by mini-css-extract-plugin
export default {"titleRow":"cz3f3PBf57V11UXDxOup"};